import React, { createRef, useEffect, useRef, useState } from 'react'
import { Tooltip, Button, Input } from 'antd'
import { Command } from 'gg-editor'
import upperFirst from 'lodash/upperFirst'
import styles from './index.scss'
import {
  UndoOutlined,
  RedoOutlined,
  CopyOutlined,
  PauseOutlined, //
  DeleteOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  CompressOutlined, //
  RestOutlined, //
  BackwardFilled,
  ForwardFilled,
  SelectOutlined, //
  GroupOutlined, //
  UngroupOutlined,
} from '@ant-design/icons'

const ToolbarButton = (props) => {
  // console.log(props)
  const { command, icon, text, dataChart } = props

  const urlPage = window.location.href
  const split = urlPage.split('/')
  const [oldUrl, setOldURL] = useState('KKK')

  // console.log(OldUrl)

  // console.log(split[5])

  const iconr = (com) => {
    if (com == 'undo') {
      return <UndoOutlined style={{ color: 'white', fontSize: '150%' }}></UndoOutlined>
    }
    if (com == 'redo') {
      return <RedoOutlined style={{ color: 'white', fontSize: '150%' }}></RedoOutlined>
    }
    if (com == 'copy') {
      return <CopyOutlined style={{ color: 'white', fontSize: '150%' }}></CopyOutlined>
    }
    if (com == 'paste') {
      return <PauseOutlined style={{ color: 'white', fontSize: '150%' }}></PauseOutlined>
    }
    if (com == 'delete') {
      return (
        <DeleteOutlined style={{ color: 'white', fontSize: '150%' }}></DeleteOutlined>
      )
    }
    if (com == 'zoomIn') {
      return (
        <ZoomInOutlined style={{ color: 'white', fontSize: '150%' }}></ZoomInOutlined>
      )
    }
    if (com == 'zoomOut') {
      return (
        <ZoomOutOutlined style={{ color: 'white', fontSize: '150%' }}></ZoomOutOutlined>
      )
    }
    if (com == 'autoZoom') {
      return (
        <CompressOutlined style={{ color: 'white', fontSize: '150%' }}></CompressOutlined>
      )
    }
    if (com == 'resetZoom') {
      return <RestOutlined style={{ color: 'white', fontSize: '150%' }}></RestOutlined>
    }
    if (com == 'toBack') {
      return (
        <BackwardFilled style={{ color: 'white', fontSize: '150%' }}></BackwardFilled>
      )
    }
    if (com == 'toFront') {
      return <ForwardFilled style={{ color: 'white', fontSize: '150%' }}></ForwardFilled>
    }
    if (com == 'multiSelect') {
      return (
        <SelectOutlined style={{ color: 'white', fontSize: '150%' }}></SelectOutlined>
      )
    }
    if (com == 'addGroup') {
      return <GroupOutlined style={{ color: 'white', fontSize: '150%' }}></GroupOutlined>
    }
    if (com == 'unGroup') {
      return (
        <UngroupOutlined style={{ color: 'white', fontSize: '150%' }}></UngroupOutlined>
      )
    }
  }

  useEffect(() => {
    if (oldUrl != 'KKK') {
      if (dataChart != undefined) {
        document.getElementById('1234').click()
        setOldURL('KKK')
      }
    }
  }, [dataChart])

  useEffect(() => {
    setOldURL(split[5])
  }, [split[5]])

  if (command == 'autoZoom') {
    return (
      <div>
        <Command name={command}>
          <Tooltip title={text || upperFirst(command)} placement="bottom">
            {iconr(command)}
            <Button id="1234" style={{ display: 'none' }}></Button>
          </Tooltip>
        </Command>
      </div>
    )
  } else {
    return (
      <div>
        <Command name={command}>
          <Tooltip title={text || upperFirst(command)} placement="bottom">
            {iconr(command)}
          </Tooltip>
        </Command>
      </div>
    )
  }
}

export default ToolbarButton
